import EmailShipping from './components/EmailShipping';
export default EmailShipping;